import { ChevronLeft, ChevronRight, Download, ZoomIn, ZoomOut } from 'lucide-react';

export const PdfViewerToolbar = ({
  documentTitle,
  scale,
  pageNumber,
  numPages,
  pdfUrl,
  onZoomOut,
  onZoomIn,
  onPrevPage,
  onNextPage,
}) => (
  <div className="flex items-center justify-between border-b border-zinc-800 bg-zinc-900 px-4 py-3">
    <div className="flex items-center gap-4">
      <h1 data-testid="pdf-viewer-title" className="max-w-md truncate text-sm font-medium">{documentTitle}</h1>
      <span className="rounded bg-blue-900/30 px-2 py-1 text-xs text-blue-400">PDF</span>
    </div>

    <div className="flex items-center gap-2">
      <button data-testid="pdf-zoom-out-button" onClick={onZoomOut} className="rounded p-2 transition-colors hover:bg-zinc-800" title="Zoom arrière">
        <ZoomOut className="h-4 w-4" />
      </button>
      <span className="w-12 text-center text-xs text-zinc-400">{Math.round(scale * 100)}%</span>
      <button data-testid="pdf-zoom-in-button" onClick={onZoomIn} className="rounded p-2 transition-colors hover:bg-zinc-800" title="Zoom avant">
        <ZoomIn className="h-4 w-4" />
      </button>

      <div className="mx-2 h-6 w-px bg-zinc-700" />

      <button data-testid="pdf-prev-page-button" onClick={onPrevPage} disabled={pageNumber <= 1} className="rounded p-2 transition-colors hover:bg-zinc-800 disabled:cursor-not-allowed disabled:opacity-50">
        <ChevronLeft className="h-4 w-4" />
      </button>
      <span className="text-xs text-zinc-400">{pageNumber} / {numPages || '?'}</span>
      <button data-testid="pdf-next-page-button" onClick={onNextPage} disabled={pageNumber >= numPages} className="rounded p-2 transition-colors hover:bg-zinc-800 disabled:cursor-not-allowed disabled:opacity-50">
        <ChevronRight className="h-4 w-4" />
      </button>

      <div className="mx-2 h-6 w-px bg-zinc-700" />

      <a data-testid="pdf-download-link" href={pdfUrl} download className="rounded p-2 transition-colors hover:bg-zinc-800" title="Télécharger">
        <Download className="h-4 w-4" />
      </a>
    </div>
  </div>
);
